
import { Route } from '../../../apps/pu-links/domain/Route'
import { SearchFilters } from '../../../apps/search/schemas'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { SearchSummaryBarProps } from './SearchSummaryBarProps'

@Component
export default class SearchSummaryBar
  extends Vue
  implements SearchSummaryBarProps
{
  @Prop()
    searchFilters: SearchFilters

  @Prop({ default: null })
    searchReferrerRoute: Route | null

  @Prop({ required: false })
    campsiteSlug?: string

  @Prop({ required: false })
    ptsViewed: number

  get hasDates() {
    const dates = this.searchFilters.dates
    // eslint-disable-next-line getter-return
    if (!dates || (!dates.arrive && !dates.depart)) return
    return true
  }
}
